import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们_品牌介绍与联系方式"
        description="韩国漫画网致力于提供韩漫免费阅读和漫画在线服务，拥有无遮韩国漫画大全。了解我们的品牌故事、发展历程和联系方式，韩漫免费阅读尽在韩国漫画网。"
        keywords="韩国漫画网,关于我们,韩漫免费阅读,漫画在线,品牌介绍,联系方式"
        canonicalUrl="/about"
        schemaData={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于韩国漫画网',
            description: '韩国漫画网致力于提供韩漫免费阅读和漫画在线服务，拥有无遮韩国漫画大全。',
            url: 'https://www.koreancomic.cn/about',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, item: { '@id': 'https://www.koreancomic.cn', name: '首页' } },
                { '@type': 'ListItem', position: 2, item: { '@id': 'https://www.koreancomic.cn/about', name: '关于我们' } },
              ],
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩国漫画网',
            url: 'https://www.koreancomic.cn',
            description: '韩国漫画网提供韩漫免费阅读和漫画在线服务，包含无遮韩国漫画大全。',
            foundingDate: '2020',
            email: 'contact@koreancomic.cn',
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              streetAddress: '漫画大厦12层',
            },
            contactPoint: [
              {
                '@type': 'ContactPoint',
                contactType: 'customer service',
                email: 'contact@koreancomic.cn',
                availableLanguage: ['Chinese'],
              },
            ],
          },
        ]}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="max-w-4xl mx-auto px-4 md:px-6 pt-24 pb-20">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mb-16">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于韩国漫画网
            </h1>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
              韩国漫画网成立于2020年，是国内领先的韩漫免费阅读平台。我们致力于为广大漫画爱好者提供最优质、最全面的韩国漫画在线阅读服务。
            </p>

            <div className="rounded-2xl overflow-hidden mb-8 bg-background-200 h-[300px] md:h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cozy%20office%20space%20with%20bookshelves%20filled%20with%20comics%20and%20manga%2C%20warm%20ambient%20lighting%2C%20reading%20nook%20with%20comfortable%20chairs%2C%20creative%20workspace%20with%20digital%20screens%20displaying%20webtoons%2C%20artistic%20atmosphere%2C%20professional%20photography%20style&width=1200&height=600&seq=about-hero-01&orientation=landscape"
                alt="韩国漫画网办公环境"
                title="韩国漫画网办公环境"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
              品牌介绍
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                韩国漫画网自创立以来，始终秉持"让好漫画触手可及"的理念，专注于韩国漫画的收集、整理与分发。我们与多家韩国漫画出版商建立了紧密的合作关系，确保第一时间为国内读者带来最新、最热的韩漫佳作。
              </p>
              <p>
                我们的团队由一群热爱漫画、精通互联网技术的专业人士组成。从内容筛选到用户体验优化，每个环节都精益求精。我们相信，好的漫画应该被更多人看到，好的阅读体验应该让更多人享受。
              </p>
              <p>
                目前，韩国漫画网已收录超过2000部韩国漫画作品，涵盖爱情、奇幻、动作、悬疑、喜剧、校园、都市、古风八大类型。每日服务超过50万名读者，已成为国内最受欢迎的韩漫阅读平台之一。
              </p>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
              我们的优势
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: 'ri-book-open-line', title: '海量内容', desc: '收录2000+部韩漫作品，涵盖八大热门类型，每日持续上新' },
                { icon: 'ri-flashlight-line', title: '极速更新', desc: '与韩国出版同步更新，热门作品每日更新一话，永不错过精彩' },
                { icon: 'ri-smartphone-line', title: '多端适配', desc: '响应式设计完美适配手机、平板和电脑，随时随地畅享阅读' },
                { icon: 'ri-shield-check-line', title: '高清画质', desc: '采用高清图像传输技术，原版画质清晰呈现，零压缩零损失' },
              ].map((item, i) => (
                <div
                  key={i}
                  className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
                >
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                    <i className={`${item.icon} text-lg text-accent-700`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
              媒体声誉
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                {
                  source: '中国漫画产业报告',
                  quote: '韩国漫画网作为国内领先的韩漫阅读平台，凭借其丰富的内容库和优秀的用户体验，成为韩漫爱好者的首选平台。',
                },
                {
                  source: '数字阅读周刊',
                  quote: '在韩国漫画细分领域，韩国漫画网以其专注和专业的运营理念，为用户提供了高质量的漫画在线阅读服务。',
                },
                {
                  source: 'ACG产业观察',
                  quote: '韩国漫画网在内容引进和用户体验方面的持续投入，使其在竞争激烈的漫画阅读市场中保持了领先地位。',
                },
                {
                  source: '互联网文化评论',
                  quote: '作为韩漫垂直领域的代表平台，韩国漫画网在内容多样性和用户服务方面树立了行业标杆。',
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70"
                >
                  <p className="text-sm text-foreground-600 leading-relaxed italic mb-3">
                    &ldquo;{item.quote}&rdquo;
                  </p>
                  <p className="text-xs text-foreground-400 font-medium">
                    —— {item.source}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-accent-700"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">
                  邮箱
                </h3>
                <a
                  href="mailto:contact@koreancomic.cn"
                  className="text-sm text-primary-600 hover:text-primary-700 block"
                >
                  contact@koreancomic.cn
                </a>
              </div>

              <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl text-accent-700"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">
                  地址
                </h3>
                <p className="text-sm text-foreground-500">
                  北京市朝阳区漫画大厦12层
                </p>
              </div>

              <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-time-line text-xl text-accent-700"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">
                  工作时间
                </h3>
                <p className="text-sm text-foreground-500">
                  周一至周五 9:00 - 18:00
                </p>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}